var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shortlist-edit-footer"},[_c('button',{staticClass:"leave-button",on:{"click":_vm.exitShortlist}},[_vm._v(" Exit without saving ")]),_c('button',{on:{"click":_vm.internalNav}},[_vm._v(" "+_vm._s(_vm.currentStep === 0 ? "Continue" : "Go back")+" ")]),_c('button',{on:{"click":_vm.saveShortlist}},[_vm._v("Save")])])
}
var staticRenderFns = []

export { render, staticRenderFns }